<template>
  <v-row max-width="290px" min-width="290px">
    <DateField
      v-bind:placeholder="this.$t('from')"
      :date="dateFromC"
      :label="label"
      :prependIcon="'mdi-calendar-range'"
      v-on:changed="(date) => this.onChange(date, 'from')"
      style="z-index: 3"
    />
    <DateField
      v-bind:placeholder="this.$t('to')"
      :date="dateToC"
      v-on:changed="(date) => this.onChange(date, 'to')"
      style="z-index: 3"
    />
  </v-row>
</template>
<script>
import DateField from '@/components/DateField';
export default {
  props: {
    label: String,
    dateBegin: String,
    dateEnd: String,
  },
  components: {
    DateField,
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null,
    };
  },
  watch: {
    dateBegin(value) {
      this.dateFrom = value;
    },
    dateEnd(value) {
      this.dateTo = value;
    },
  },
  computed: {
    dateFromC() {
      return this.dateFrom;
    },
    dateToC() {
      return this.dateTo;
    },
  },
  methods: {
    onChange(date, type) {
      switch (type) {
      case 'from':
        this.dateFrom = date;
        break;
      case 'to':
        this.dateTo = date;
        break;
      }

      if (this.CheckDates()) {
        this.SwapDate();
      }
      this.$emit('changed', this.dateFrom, this.dateTo);
    },

    CheckDates() {
      if (!this.dateFrom || !this.dateTo) return false;

      const dateTo = this.dateTo.split('-');
      const dateFrom = this.dateFrom.split('-');

      if (dateFrom[0] < dateTo[0]) return false;
      if (dateFrom[0] === dateTo[0] && dateFrom[1] < dateTo[1]) return false;
      if (
        dateFrom[0] === dateTo[0] &&
        dateFrom[1] === dateTo[1] &&
        dateFrom[2] <= dateTo[2]
      )
        return false;

      return true;
    },

    SwapDate() {
      const tmp = this.dateFrom;
      this.dateFrom = this.dateTo;
      this.dateTo = tmp;
    },
  },
};
</script>